export const faqs = [
    {
        question: "Does Bajaj Finserv accept loan settlement?",
        answer:
            "Yes, Bajaj Finserv accepts loan settlement (One Time Settlement or OTS) for borrowers who are genuinely unable to repay their loans due to financial hardships like job loss, medical emergencies, or business failure. However, this is at the NBFC's discretion and usually offered when the loan becomes a Non-Performing Asset (NPA).",
    },
    {
        question: "How can I settle my Bajaj Finserv EMI Card debt?",
        answer:
            "To settle your Bajaj Finserv EMI Card or personal loan debt, you need to stop making payments and allow the account to go into default (usually 90 days). Once you receive settlement offers or legal notices, you can negotiate with Bajaj Finserv for a reduced lump sum payment. It is highly recommended to hire a legal expert to handle negotiations and ensure you get a proper settlement letter.",
    },
    {
        question: "Will settling my Bajaj Finserv loan affect my CIBIL score?",
        answer:
            "Yes, settling a loan will negatively impact your CIBIL score. The account status will be reported as 'Settled' instead of 'Closed', which indicates that the full amount was not paid. This can drop your score by 50-100 points. However, you can rebuild your score over time (12-24 months) by using secured credit cards and paying bills on time.",
    },
    {
        question: "Can Bajaj Finserv file a legal case against me for non-payment?",
        answer:
            "Yes, Bajaj Finserv can initiate legal action. Common actions include sending legal notices, filing a Section 138 case (for cheque/NACH bounce), or initiating arbitration proceedings. Legal representation is crucial to handle these notices effectively and avoid legal complications.",
    },
    {
        question: "What is the minimum settlement amount Bajaj Finserv accepts?",
        answer:
            "The settlement amount depends on various factors like the total outstanding, the age of the default, and your financial situation. Typically, settlements can range from 30% to 50% of the total outstanding amount. Skilled negotiation can help achieve a lower settlement figure.",
    },
    {
        question: "How do I get a settlement letter from Bajaj Finserv?",
        answer:
            "Once a settlement amount is agreed upon verbally, you must insist on an official Settlement Letter from Bajaj Finserv on their letterhead. This letter should clearly state the settlement amount, payment due date, and that no further dues will remain after this payment. Do not make any payment without this letter.",
    },
];
